import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import _ from "lodash";
import {
  IconLocation1,
  IconPersonSupport,
  IconPhone,
  IconSecurity,
} from "../../../assets/icons";
import { isMobile } from "react-device-detect";
import eNamadImage from "../../../assets/images/enamad.jpg";
import phoneCall from "../../../assets/images/phone-call.svg";
import buildingImg from "../../../assets/images/building-bro.svg";
import ApiContact from "../../../core/api/api.contact";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [pageContent, setPageContent] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  useEffect(() => {
    getData();
  }, []);
  async function getData() {
    setLoadingData(true);
    try {
      const contactInfo = await ApiContact.getInfos();
      const contactInfoContent = JSON.parse(contactInfo?.content || []);
      setPageContent(contactInfoContent);
    } catch (error) {
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }

  return (
    <>
      {isMobile ? (
        <Container fluid className=" bg-light-3">
          <Container className="py-4">
            <Row className=" px-2 pt-4 pb-3 bg-white rounded-4 mt-xl-3 mt-1 shadow-sm">
              <Col className="line-height-1">
                <div className="fs-normal fw-bold mb-2">
                  <IconPersonSupport /> ارتباط با ما
                </div>
                {loadingData ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={2}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <div
                    className="fs-08 "
                    dangerouslySetInnerHTML={{
                      __html: pageContent.HeaderContent,
                    }}
                  ></div>
                )}

                <div className="border-bottom py-2 my-2 border-top">
                  {loadingData ? (
                    <SkeletonTheme>
                      <div className="d-flex align-items-center justify-content-between py-2">
                        <div className="fs-08">
                          <Skeleton height="15px" width={100}></Skeleton>
                        </div>
                        <div className="fw-bold">
                          <a className="text-dark">
                            <span className="fs-09">
                              <Skeleton height="15px" width={100}></Skeleton>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between py-2">
                        <div className="fs-08">
                          <Skeleton height="15px" width={100}></Skeleton>
                        </div>
                        <div className="fw-bold">
                          <a className="text-dark">
                            <span className="fs-09">
                              <Skeleton height="15px" width={100}></Skeleton>
                            </span>
                          </a>
                        </div>
                      </div>
                    </SkeletonTheme>
                  ) : (
                    pageContent.Phones?.map((item) => (
                      <div className="d-flex align-items-center justify-content-between py-2">
                        <div className="fs-08">{item.Title} </div>
                        <div className="fw-bold">
                          <a href={`tel:${item.Phone}`} className="text-dark">
                            <span className="fs-09">{item.Phone}</span>
                            <span className="bg-success-light-1 rounded-2 p-05 ms-1">
                              <IconPhone fillColor="#07834f" />
                            </span>
                          </a>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                {loadingData ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={4}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageContent.PageContent,
                    }}
                  ></div>
                )}
              </Col>
            </Row>
            <Row className=" px-2 py-4 bg-white rounded-4 mt-xl-3 mt-3 shadow-sm">
              <Col className="line-height-1">
                <div className="fs-normal fw-bold mb-2">
                  <IconSecurity /> مجوزهای تفریحان
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-08 text-align-justify">
                    سایت تفریحان دارای مجوز از مرکز توسعه تجارت الکترونیکی وزارت
                    صنعت ، معدن و تجارت می باشد.
                  </div>
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                  >
                    <img
                      alt="eNamad"
                      width="75px"
                      referrerPolicy="origin"
                      className="rounded-3 h-100 "
                      src={eNamadImage}
                      style={{ cursor: "pointer" }}
                      id="A32132KLXam6f2jcPJyV"
                    />
                  </a>
                </div>
              </Col>
            </Row>
            <Row className=" px-2 py-4 bg-white rounded-4 mt-xl-3 mt-3 shadow-sm">
              <Col className="line-height-1">
                <div className="fs-normal fw-bold mb-2">
                  <IconLocation1 /> آدرس دفتر
                </div>
                {loadingData ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={3}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <div className="fs-08 text-align-justify">
                    {pageContent.Address}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Container>
      ) : (
        <>
          <Container fluid className=" bg-light-3">
            <Container className="px-4 py-4">
              <Row className="px-3  py-4 bg-white rounded-4 shadow-sm">
                <Col className="line-height-2">
                  <div className="fs-102 fw-bold mb-2">
                    <IconPersonSupport /> ارتباط با ما
                  </div>
                  {loadingData ? (
                    <SkeletonTheme>
                      <Skeleton height="18px" count={1}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <div
                      className="border-top pt-3"
                      dangerouslySetInnerHTML={{
                        __html: pageContent.HeaderContent,
                      }}
                    ></div>
                  )}
                  {loadingData ? (
                    <SkeletonTheme>
                      <div className="d-flex align-items-center ">
                        <div className="d-flex py-2 pe-5">
                          <div className="fw-bold fs-09">
                            <Skeleton height="18px" width={100}></Skeleton>
                          </div>
                          <div className="text-muted fs-075 pb-2 ps-2">
                            <Skeleton height="18px" width={100}></Skeleton>
                          </div>
                        </div>
                        <div className="d-flex py-2 pe-5">
                          <div className="fw-bold fs-09">
                            <Skeleton height="18px" width={100}></Skeleton>
                          </div>
                          <div className="text-muted fs-075 pb-2 ps-2">
                            <Skeleton height="18px" width={100}></Skeleton>
                          </div>
                        </div>
                      </div>
                    </SkeletonTheme>
                  ) : (
                    <Row className="d-flex align-items-center ">
                      {pageContent.Phones?.map((item) => (
                        <>
                          <Col lg="4" className="d-flex py-2">
                            <div className="fw-bold fs-09">{item.Phone}</div>
                            <div className="text-muted fs-075  ps-2">
                              {item.Title}
                            </div>
                          </Col>
                        </>
                      ))}
                    </Row>
                  )}
                  {loadingData ? (
                    <SkeletonTheme>
                      <Skeleton height="18px" count={3}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageContent.PageContent,
                      }}
                    ></div>
                  )}
                </Col>
                <Col md="4" className="d-none d-lg-block text-end">
                  <img src={phoneCall} alt="icon" className="w-75" />
                </Col>
              </Row>

              <Row className="px-3 mt-3 pt-4 bg-white rounded-4 shadow-sm">
                <Col className="line-height-2">
                  <div className="fs-102 fw-bold mb-2">
                    <IconLocation1 /> آدرس
                  </div>
                  <div className="border-top pt-3">
                    {loadingData ? (
                      <SkeletonTheme>
                        <Skeleton height="18px" count={1}></Skeleton>
                      </SkeletonTheme>
                    ) : (
                      pageContent.Address
                    )}
                  </div>
                  <div className=" fs-08 text-muted pt-2">
                    این دفتر فقط جهت انجام کارهای مهم اداری می باشد و هیچ گونه
                    تفریحی در این مکان انجام نمی شود.
                  </div>

                  <div className="d-flex align-items-center ">
                    <div className="fs-08 text-muted pt-1 text-align-justify">
                      سایت تفریحان دارای مجوز از مرکز توسعه تجارت الکترونیکی
                      وزارت صنعت ، معدن و تجارت می باشد. <br />
                      جهت مشاهده مجوزها روی لینک{" "}
                      <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        مشاهده مجوز
                      </a>{" "}
                      کلیلک نمایید.
                    </div>
                  </div>
                </Col>
                <Col md="4" className="d-none d-lg-block text-end">
                  <img src={buildingImg} alt="icon" className="w-75" />
                </Col>
              </Row>
            </Container>
          </Container>
        </>
      )}
    </>
  );
}
export default ContactUs;
